import bookmarkMiddleware from './bookmarkMiddleware';

export default [bookmarkMiddleware];
